module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_35.27284579.mp3";